import { Vector2 } from "three";
import { OnAnimationFrame } from "../animation/OnAnimationFrame";
import { DOMHitTest } from "../dom-tools/DOMHitTest";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType } from "../dom-tools/ElementType";
import { DOMOrientation } from "../dom/DOMOrientation";
import { MathX } from "../math/MathX";
import { RenderQuality } from "../../library-templates/render--quality/RenderQuality";

export class ParallaxBlock
{
  static readonly type         = new ElementType( "parallax--block" );
  static readonly layer        = new ElementType( "parallax--layer" );
  static readonly strength     = new ElementAttribute( "strength" ); 
  static readonly clamping        = new ElementAttribute( "clamping" );  

  private static attachedGlobalListeners = false;
  private static parallexElements:HTMLElement[] = [];
  private static documentTimeStart = 0;

  static applyOnDocument( onAnimationFrame:OnAnimationFrame )
  {
    ParallaxBlock.attachGlobalListener( onAnimationFrame );
    ParallaxBlock.documentTimeStart = new Date().getTime();

    ParallaxBlock.parallexElements = ParallaxBlock.type.queryAll( document.body ) as HTMLElement[];
    
  }

  static attachGlobalListener( onAnimationFrame:OnAnimationFrame )
  {
    if ( ParallaxBlock.attachedGlobalListeners )
    {
      return;
    } 

    ParallaxBlock.attachedGlobalListeners = true;

    onAnimationFrame.addListener(
      ()=>
      {
        ParallaxBlock.#updateElements();
      }
    );

  }

  static #updateElements()
  {
    if ( DOMOrientation.isPortrait )
    {
      return;
    }

    let scroll = window.scrollY;
    let time   = ( new Date().getTime() - ParallaxBlock.documentTimeStart ) / 1000;
    ParallaxBlock.parallexElements.forEach( e => ParallaxBlock.applyParallaxEffect( e, scroll, time ) );
  }


  static applyParallaxEffect( element:Element, windowScroll:number, time:number )
  { 
    let elementPageBox = DOMHitTest.getPageBox( element );
    let elementScroll = ( windowScroll - elementPageBox.min.y ) / elementPageBox.getSize( new Vector2() ).y;

    let clamped = MathX.clamp01( elementScroll );

    let layers = ParallaxBlock.layer.queryAll( element ) as HTMLElement[];

    let quality = RenderQuality.get();    

    layers.forEach(
      ( l )=>
      {
        let scroll = elementScroll;

        if ( ParallaxBlock.clamping.in( l ) )
        {
          scroll = clamped;          
        }   

        

        let numbers  = ParallaxBlock.strength.parseNumbers( l, [ 0, 0 ] );
        let scrollEffect = numbers[ 0 ];
        let scrollOffset = numbers.length > 1 ? numbers[ 1 ] : 0;

        let strength = scrollEffect * scroll + scrollOffset;        

        if ( RenderQuality.onlyOnQuality.in( l ) )
        {
          let level = RenderQuality.onlyOnQuality.from( l );
          let containsQuality = level.indexOf( quality ) != -1;

          if ( ! containsQuality )
          {
            l.style.transform = `translate3d(0,calc( ${scrollOffset} * var(--sw) ), 0)`;
            return;
          }
        }

        l.style.transform = `translate3d(0,calc( ${strength} * var(--sw) ), 0)`;
      }
    )
  }
}
